import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import Input from 'components/UI/Input';
import * as styles from './subscribeContainer.module.scss';

const Subscribe = ({ subscribe }) => {
  const [email, setEmail] = useState('');

  const handleChangeInput = useCallback(
    ({ target: { value } }) => setEmail(value),
    []
  );

  const handleSubmit = useCallback((e) => {
    e.precentDefault();
  }, []);

  return (
    <div className={classnames(styles.subscribe)}>
      <p className={classnames(styles.textWrap, 'cr-reg')}>
        <span className={classnames(styles.title)}>{subscribe.title}</span>{' '}
        &#160;
        <span className={classnames(styles.subtitle)}>
          {subscribe.subtitle}
        </span>
      </p>

      <form onSubmit={handleSubmit}>
        <Input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={handleChangeInput}
        />
      </form>
    </div>
  );
};

export default Subscribe;
